import { EOrgUserStatus } from "../../../../shared/oversight-core/enums/org-user-status";
import { getOrgUserStatusInfo } from "../../../../shared/oversight-core/utils/get-org-user-info";
import styles from "./user-status.module.scss";

interface IProps {
  status: EOrgUserStatus;
}

const UserStatus = (props: IProps) => {
  const { label, color } = getOrgUserStatusInfo(props.status);

  return (
    <div className="d-flex align-items-center gap-2 text-light font-size-13">
      <span className={styles.dot} style={{ backgroundColor: color }} />
      {label}
    </div>
  );
};

export default UserStatus;
